module.exports = "//img1.rrcimg.com/_next/static/src/assets/dg_2hkX9.png";